// Import the package.json version
import packageJson from "../../package.json";
import localService from "@/services/local.service";

// Set the app version in the global window object
const _window = window;
_window.appVersion = packageJson.version;

// Function to clear the cache and reload the page
const refreshCacheAndReload = () => {
	console.log("Clearing cache and hard reloading...");
	if (caches) {
		// Service worker cache should be cleared with caches.delete()
		caches.keys().then(function (names) {
			for (let name of names) caches.delete(name);
		});
	}
	// delete browser cache and hard reload
	window.location.reload(true);
};

// Function to check for a new version using async/await
const checkForNewVersion = async () => {
	try {
		const response = await localService.get(
			"/meta.json?v=" + new Date().getTime(),
		);
		if (!response?.version) {
			throw new Error("metadata not found");
		}

		const latestVersion = response.version;
		const currentVersionInBrowser = _window.appVersion;

		const shouldForceRefresh = latestVersion !== currentVersionInBrowser;
		if (shouldForceRefresh) {
			console.log(
				`We have a new version - ${latestVersion}. Should force refresh`,
			);
			refreshCacheAndReload();
		}
	} catch (error) {
		console.error("Failed to check for new version:", error);
	}
};

// Export the function for manual initialization
export { checkForNewVersion };
